declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const fbPixelId = config.public.fbPixelId;

    // console.log('Facebook Pixel ID:', fbPixelId);

  
    if (!fbPixelId) return;
  
    // Inject Facebook Pixel base script
    (function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Node) {
      if (f.fbq) return;
      n = f.fbq = function (...args: any[]) {
        n.callMethod
          ? n.callMethod.apply(n, args)
          : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  
    // Initialize and track initial page view
    window.fbq('init', fbPixelId);
    window.fbq('track', 'PageView');
  });
  